import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { animateFast, fadeIn } from 'components/Common/Animation/Animation';

export const Text = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  lineHeight: '100%',
  fontWeight: 500,
  textTransform: 'uppercase',
}));

export const Root = styled(Box)(({ theme }) => ({
  width: 120,
  height: 120,
  color: theme.palette.primary.main,
  border: '2px dashed',
  borderColor: theme.palette.primary.main,
  backgroundColor:  theme.palette.background.paper,
  borderRadius: '8px',
  display: 'none',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  WebkitAnimationName: fadeIn,
  animationName: fadeIn,
  ...animateFast,
  '& > svg': {
    width: 58,
    height: 'auto',
  }
}));

export const IconContainer = styled(Box)(() => ({
  display: 'none',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px'
}));
